var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-base',[_c('m-v3'),_vm._v(" "),_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#landing-top'),expression:"'#landing-top'"},{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],staticClass:"go-top"},[_c('icon',{attrs:{"name":"chevron-up"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0964cf14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing2.vue
// module id = null
// module chunks = 